<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
<main-layout classes="more-view">
    <main-menu-header />
    <div class="more-header-container">
        <div class="more-header">
            <h1>더보기</h1>
        </div>
    </div>
    <div class="more-list-container">
        <div class="more-list">
            <button class="more-button on" @click="showUploadKosiwonView">고시원 등록 신청</button>
        </div>
        <div class="more-list">
            <button class="more-button on" @click="showUploadKosiwonHomepage">고시락 패키지 신청</button>
        </div>
        <div class="more-list">
            <button class="more-button on" @click="showInformationWorkPage">고시락 홍보 방법</button>
        </div>
        <div class="more-list">
            <button class="more-button" @click="moveToHuesik">고시원 창업</button>
        </div>
        <div class="more-list">
            <button class="more-button" @click="moveToKosirockBlog">고시락 블로그 보기</button>
        </div>
        <div class="more-list">
            <button class="more-button" @click="moveToPolicy">고시락 이용약관</button>
        </div>
    </div>
    <default-footer></default-footer>
</main-layout>
</template>

<script>
import MainLayout from '../components/Layout/MainLayout'
import MainMenuHeader from '../components/Header/MainMenuHeader'
import DefaultFooter from '../components/Footer/index'

export default {
    name: 'More.vue',
    components: {
        DefaultFooter,
        MainMenuHeader,
        MainLayout
    },
    methods: {
        showUploadKosiwonView() {
            this.$router.push("/register");
            // window.open('http://ad.kosirock.com/#/register')
            // window.open('https://forms.gle/9LBmavTC1ekqDYxf8')
        },
        showUploadKosiwonHomepage() {
            window.open('https://forms.gle/U1ge5vr31bN6bFpo7')
        },
        moveToKosirockBlog() {
            window.open('https://blog.naver.com/kosirock')
        },
        moveToHuesik() {
            window.open('https://huesik.co.kr/')
        },
        showInformationWorkPage() {
            window.open('https://docs.google.com/gview?embedded=true&url=https://s3.ap-northeast-2.amazonaws.com/huesik.static/kosirock_new_information_250611.pdf')
        },
        moveToPolicy() {
            window.open('https://kosirock.com/policy')
        }
    }
}
</script>

<style lang="less" scoped>
@import "../assets/css/palette";

.more-view {
    overflow: auto;

    .more-header-container {
        background: @white;

        .more-header {
            width: 100%;
            height: 6.25rem;
            margin: auto;
            border-bottom: 1px solid #dddddd;

            h1 {
                line-height: 6.25rem;
                vertical-align: middle;
                font-weight: bold;
                color: @black-two;
                font-size: 2rem;
            }
        }
    }

    .more-list-container {
        padding: 5.75rem 5rem 0 5rem;

        .more-list {
            padding-bottom: 3.75rem;

            .more-button {
                height: 5rem;
                width: 100%;
                color: @windows-blue;
                background-color: white;
                font-size: 1.75rem;
                font-weight: bold;
                border: 2px solid @windows-blue;

                &.on {
                    color: white;
                    background-color: @windows-blue;
                }
            }
        }
    }
}
</style>
